
<template>
  <div>
    <v-card style="border-radius:12px" flat>
      <v-card-title primary-title>
        <div class="headline mb-0">Segmentos</div>
      </v-card-title>
      <v-card-text>
        <v-row align="center">
          <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Encontrar"></v-text-field>
          <v-btn text small color="primary" @click="dialog_segment = true" rounded><v-icon left
              small>mdi-plus</v-icon>segmento</v-btn>
        </v-row>
        <v-data-table :headers="headers" :items="all_segments"   :loading='loading' :search='search'
          class="elevation-0" mobile-breakpoint="1">
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.name }}</td>
            <td class="text-xs-center">{{ props.item.code }}</td>
            <td class="text-xs-center">
              <v-btn icon color="primary" @click="editSegment(props.item)" rounded><v-icon
                  small>mdi-pencil</v-icon></v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog_segment" scrollable persistent max-width="500px" transition="dialog-transition">
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Segmento de Produto</div>
        </v-card-title>
        <v-card-text>
          <v-form ref="formSegment" v-model="is_valid" lazy-validation>
            <v-text-field v-model="segment.name" label="Nome" prepend-icon="mdi-information"
              :rules="[rules.required]"></v-text-field>
            <v-text-field v-model="segment.code" label="Código" prepend-icon="mdi-information"></v-text-field>
            <v-stepper v-if="false" v-model="stepper" vertical class="ml-1 mr-1">

              <v-stepper-step :complete="stepper > 1" step="1" :editable="stepper > 1">
                Identificação
              </v-stepper-step>

              <v-stepper-content :complete="stepper > 1" step="1">
                <v-col lg='9' md='10'>
                  <v-card color="white lighten-1" class="mb-2 pa-3" height="">
                  </v-card>
                  <v-btn text @click="stepper = 1" disabled small><v-icon large color="red darken-2" size="19">mdi-arrow-up-bold</v-icon></v-btn>
                  <f-btn @click="submitSegment()" :disabled="!is_valid" save></f-btn>
                </v-col>
              </v-stepper-content>
            </v-stepper>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <f-btn @click="reloadSegment()" cancel></f-btn>
          <f-btn @click="submitSegment()" save></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Api from '@/api/index';

export default {
  name: 'RegisterSegment',
  data() {
    return {
      headers: [
        { align: 'center', text: 'Nome', value: 'name' },
        { align: 'center', text: 'Código', value: 'code' },
        { align: 'center', text: 'Ação', value: 'name' },
      ],
      loading: false,
      search: null,
      key: null,
      segment: {
        name: null,
        code: null,
      },
      dialog_segment: false,
      stepper: 1,
      is_valid: true,
      rules: {
        required: v => !!v || 'Campo é necessário',
      },
      all_segments: []
    }
  },
  methods: {
    getSegments() {
      this.loading = true
      Api.Supplier.indexSegment().then(r => r.data).then(d => {
        this.all_segments = [...d]
        this.loading = false
      })
    },
    submitSegment() {
      if (this.$refs.formSegment.validate()) {
        this.swallConfirmation({
          title: `Deseja cadastrar segmento?`,
          icon: 'question',
        }).then(r=>{
          if (r) {
            this.saveSegment()
          }
        })
      }
    },
    editSegment(item) {
      this.segment = { ...item }
      this.dialog_segment = true
    },
    reloadSegment() {
      this.segment = {
        name: null,
        code: null,
      }
      this.dialog_segment = false
      this.$refs.formSegment.reset()
    },
    populateAllSegments(ov, nv) {
      if (ov.id) {
        let idx = this.all_segments.findIndex((as) => as.id == ov.id)
        this.all_segments.splice(idx, 1, nv)
      } else {
        this.all_segments.push(nv)
      }
    },
    saveSegment() {
      this.loading = true
      this.segment.name = this.segment.name.trim()
      const ACTION = this.segment.id ? 'updateSegment' : 'createSegment'
      Api.Supplier[ACTION](this.segment).then(r => r.data).then(d => {
        this.populateAllSegments(this.segment, d)
        this.reloadSegment()
        this.addNotification({type: 'success',  msg: `Cadastrado com sucesso.`})
      }).catch((err) => {
        this.addNotification({type: 'error',  msg: `Não foi possível criar devido a informações incorretas ou duplicadas no sistema.`})
      }).finally(() => {
        this.loading = false
      })
    },

  },
  mounted() {
    this.getSegments();
  },
}
</script>
